import React from "react"

import { RoomExhaustAirInput } from "./inputs/RoomExhaustAirInput"
import { RoomFortluftInput } from "./inputs/RoomFortluftInput"
import { RoomOutsideAirInput } from "./inputs/RoomOutsideAirInput"
import { RoomRecirculatedAirInput } from "./inputs/RoomRecirculatedAirInput"
import { RoomRoomAirInput } from "./inputs/RoomRoomAirInput"
import { RoomSecondaryAirInput } from "./inputs/RoomSecondaryAirInput"
import { RoomSupplyAirInput } from "./inputs/RoomSupplyAirInput"
import { RoomTransferAirInput } from "./inputs/RoomTransferAirInput"

export const RoomFormAirDataTab = React.memo(() => {
  return (
    <div className="room-form-air-data-tab room-form__tab-content">
      <RoomSupplyAirInput />
      <RoomOutsideAirInput />
      <RoomExhaustAirInput />
      <RoomFortluftInput />
      <RoomTransferAirInput />
      <RoomRecirculatedAirInput />
      <RoomRoomAirInput />
      <RoomSecondaryAirInput />
    </div>
  )
})
